module.exports = __webpack_public_path__ + "static/media/deep-learning.0fd09b4b.svg";